import { render, staticRenderFns } from "./JVxeUserSelectCell.vue?vue&type=template&id=3f0163cb&scoped=true&"
import script from "./JVxeUserSelectCell.vue?vue&type=script&lang=js&"
export * from "./JVxeUserSelectCell.vue?vue&type=script&lang=js&"
import style0 from "./JVxeUserSelectCell.vue?vue&type=style&index=0&id=3f0163cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0163cb",
  null
  
)

export default component.exports